function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.504,
    height: 18.986,
    viewBox: "0 0 33.504 18.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12516",
    d: "M174.415-256.476a.746.746 0 0 0-.415.736.74.74 0 0 0 .45.744.827.827 0 0 0 1.16-1.03 1.08 1.08 0 0 0-.251-.39.983.983 0 0 0-.944-.06z",
    transform: "translate(-163.648 269.386)",
    style: {
      fill: "#505050"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12518",
    d: "m41.322-469.08 9.233-5.076v17.334l-9.233-4.733z",
    transform: "translate(-17.947 474.89)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12515",
    d: "M83.681-402.337c-2.329 1.281-4.268 2.337-4.3 2.337s-.069-.225-.069-.5a4.18 4.18 0 0 0-.5-1.8 4.688 4.688 0 0 0-1.437-1.454c-.944-.554-.329-.519-10.31-.554-6.207-.017-7.847.009-8.228.069a4.08 4.08 0 0 0-3.177 2.787c-.147.424-.156.848-.156 6.3s.009 5.878.156 6.3a4.08 4.08 0 0 0 3.177 2.787c.381.061 2.021.087 8.228.069 8.224-.026 9.133-.043 9.5-.173a4.052 4.052 0 0 0 2.753-3.644c0-.415.026-.5.13-.459.069.026 2.026 1.082 4.337 2.355 3.861 2.112 4.233 2.3 4.527 2.251a.946.946 0 0 0 .511-.268l.19-.225v-17.988l-.2-.225a.767.767 0 0 0-.537-.268c-.328-.034-.665.13-4.595 2.303zm-7.358-.026a2.517 2.517 0 0 1 1.073 1.151c.173.381.182.545.182 6.059s-.009 5.679-.182 6.06a2.517 2.517 0 0 1-1.073 1.151l-.346.19h-17.1l-.355-.19a2.388 2.388 0 0 1-1.281-1.818l-.052-.364 3.463-.026 3.463-.026.234-.242a.693.693 0 0 0 .242-.58.693.693 0 0 0-.242-.58l-.234-.242-3.471-.026-3.463-.026.026-4.475c.026-4.328.035-4.484.208-4.865a2.485 2.485 0 0 1 1.506-1.307c.121-.035 2.9-.061 7.925-.052l9.133.017zm10.933 10.786L87.23-388l-3.956-2.164-3.965-2.173v-5.627l3.965-2.173 3.956-2.163.026 3.575c.008 1.963.008 5.183 0 7.148z",
    transform: "translate(-55.5 404.643)",
    style: {
      fill: "#6f7e8e"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCall);
export default __webpack_public_path__ + "static/media/video-call.ffdca3c5b258eb5ca4e986060b448714.svg";
export { ForwardRef as ReactComponent };